import { NativeModules, Platform, AsyncStorage } from 'react-native';


const READ_URLS_STORAGE_KEY = 'safari-reading-list-urls';

export const isAvailable = () => Platform.OS === 'ios';

export const supportsUrl = async (url) => {
  if (!isAvailable()) {
    return false;
  }
  const result = await NativeModules.SafariReadingList.supportsURL(
    url,
  );
  return result;
};

const hasAlreadyBeenAdded = async (url) => {
  const readUrlsStr = await AsyncStorage.getItem(READ_URLS_STORAGE_KEY),
        readUrls = JSON.parse(readUrlsStr);

  return readUrls ? readUrls.find((u) => u === url) : false;
};

const saveAddedUrl = async (url) => {
  const readUrlsStr = await AsyncStorage.getItem(READ_URLS_STORAGE_KEY),
        readUrls = readUrlsStr ? JSON.parse(readUrlsStr) : [];

  await AsyncStorage.setItem(READ_URLS_STORAGE_KEY, JSON.stringify([...readUrls, url]));
};

export const addReadingListItemWithURL = async (url, title, description) => {
  if (!url || !isAvailable() || !supportsUrl(url) || await hasAlreadyBeenAdded(url) || (!title && !description)) {
    return false;
  }
  const result = await NativeModules.SafariReadingList.addReadingListItemWithURL(
    url,
    title || description,
    description || title,
  );
  await saveAddedUrl(url);
  return result;
};

export default { addReadingListItemWithURL, supportsUrl, isAvailable };
